export default __webpack_public_path__ + "static/media/startlater@3x.0f526165.jpg";